import { Navigate, useLocation } from "react-router-dom";
import { useMerchantAuth } from "../../context/MerchantAuthContext";

export default function MerchantProtected({ children }) {
  const { user, loading } = useMerchantAuth();
  const { pathname } = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center font-body">
        <div className="text-zinc-500 text-[11px] tracking-[0.22em] uppercase">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: pathname }} />;
  return children;
}
